import PatternDownload from '@/shared/components/patterns/PatternDownload.vue';
import GlobalKeyDownDirective from '@/shared/directives/globalKeyDown.js';
import { useProductStore } from '@/shared/pinia/modules/product';
import { setupI18n } from '@/shared/utils/i18n';
import { getProductDataFromHTML } from '@/shared/utils/product';

export const initPatternDownload = async (createApp, mountId) => {
  const mountElement = document.getElementById(mountId);

  if (!mountElement) {
    console.error(`Element with id: "${mountId}" not found.`);
    return;
  }

  const { productName, legacyId } = getProductDataFromHTML();
  const { productSku, freePattern } = mountElement.dataset;

  if (!productName || !productSku || !freePattern) return;

  const i18n = await setupI18n(window.Shopify.locale);

  const productStore = useProductStore();
  productStore.legacyId = legacyId;

  createApp(PatternDownload, {
    productName,
    productSku,
    patternPurchasable: freePattern === 'false'
  })
    .use(i18n)
    .directive('global-keydown', GlobalKeyDownDirective)
    .mount(`#${mountId}`);
};
